{
  "title": "カード図鑑",
  "intro": "お店で扱えるカードの一覧（ゲーム・セット・カード）。在庫ではありません。販売する商品はこのカードから作ります。",
  "breadcrumb": "カード図鑑内の現在地",
  "games": {
    "title": "ゲーム",
    "add": "ゲームを追加",
    "save": "ゲームを保存",
    "created": "ゲーム「{{name}}」を追加しました",
    "empty": "ゲームがまだありません",
    "empty_hint": "最初のゲーム（例：ポケモン）を追加してください。",
    "hidden": "非表示",
    "save_order": "この順番で保存",
    "undo_order": "順番を元に戻す",
    "order_saved": "順番を保存しました",
    "price_check": "価格確認",
    "price_check_title": "{{name}} の価格確認",
    "price_check_intro": "このゲームのカードを、価格を確認しないまま何日たったら黄色（そろそろ確認）・赤（期限切れ）にするか。空欄ならお店の設定を使います。",
    "warn_days": "黄色になるまでの日数",
    "alert_days": "赤になるまでの日数",
    "shop_default": "お店の設定：{{days}}",
    "days_suffix": "日",
    "price_check_rule": "{{warn}}日で黄色・{{alert}}日で赤",
    "price_check_custom": "独自の価格確認：{{warn}}日で黄色・{{alert}}日で赤",
    "price_check_saved": "価格確認の日数を保存しました",
    "days_range": "1〜365 の整数を入れてください。",
    "days_order": "黄色は赤より先です。黄色の日数は赤より小さくしてください（{{warn}} / {{alert}}）。"
  },
  "sets": {
    "title": "セット",
    "intro": "このゲームのセットです。セットを開くとカードを見たり追加したりできます。",
    "add": "セットを追加",
    "edit": "セットを変更",
    "edit_named": "{{name}} を変更",
    "save": "セットを保存",
    "created": "セット「{{name}}」を追加しました",
    "saved": "セットを保存しました",
    "empty": "セットがまだありません",
    "empty_hint": "SV2a のようなセットコードで追加してください。",
    "duplicate": "このゲームには同じコード・同じ言語のセットがすでにあります。",
    "delete": "セットを削除",
    "delete_named": "{{name}} を削除",
    "delete_title": "このセットを削除しますか？",
    "delete_consequence": "「{{name}}」をカード図鑑から削除します。販売中の商品は変わりません。",
    "deleted": "セットを削除しました",
    "in_use": "このセットにはまだカードか商品があるため削除できません。"
  },
  "cards": {
    "title": "カード",
    "intro": "このセットのカードです。日本語名と英語名を並べて表示します。",
    "add": "カードを追加",
    "edit": "カードを変更",
    "edit_named": "{{name}} を変更",
    "save": "カードを保存",
    "created": "カード「{{name}}」を追加しました",
    "saved": "カードを保存しました",
    "empty": "このセットにはまだカードがありません",
    "empty_hint": "番号と名前で最初のカードを追加してください。",
    "in_stock": "店の在庫",
    "stock_n": "在庫 {{count}} 枚",
    "stock_none": "なし",
    "delete": "カードを削除",
    "delete_named": "{{name}} を削除",
    "delete_title": "このカードを削除しますか？",
    "delete_consequence": "「{{name}}」をカード図鑑から削除します。",
    "deleted": "カードを削除しました",
    "in_use": "このカードから作った商品があるため削除できません。",
    "import": "このセットのカードを取り込む（{{source}}）",
    "imported": "{{count}} 枚取り込みました",
    "import_off": "この取り込み元はまだ使えません。"
  },
  "fields": {
    "game": "ゲーム",
    "set": "セット",
    "set_code": "セットコード",
    "set_code_hint": "カードに印刷されているもの（例：SV2a）",
    "set_name": "セット名",
    "language": "カードの言語",
    "language_hint": "カードに印刷されている言語",
    "name_en": "名前（英語）",
    "name_jp": "名前（日本語）",
    "name_ja": "名前（日本語）",
    "name_th": "名前（タイ語）",
    "number": "カード番号",
    "number_hint": "印刷どおり（例：085/165）",
    "rarity": "レアリティ",
    "card_type": "カードの種類",
    "character": "キャラクター",
    "card_name": "名前",
    "reference_image": "画像（ウェブアドレス）",
    "reference_image_hint": "インターネット上のカード画像（https://…）。カードを選ぶときに表示されます",
    "reference_image_bad": "https:// で始まるアドレスを入れてください",
    "release_date": "発売日",
    "total_cards": "セットのカード枚数",
    "total_cards_bad": "整数で入れてください",
    "logo": "セットのロゴ",
    "publisher": "発売元"
  },
  "languages": {
    "JP": "日本語",
    "EN": "英語",
    "TH": "タイ語",
    "KR": "韓国語",
    "ZH": "中国語"
  },
  "picker": {
    "label": "どのカード？",
    "hint": "日本語名・英語名・番号、またはセットコード＋番号（例：SV2a 085）を入力。鑑定品の番号をスキャンしても大丈夫です。",
    "placeholder": "例：ブラッキー / Umbreon / 085",
    "set_filter": "このセットだけ",
    "all_sets": "すべてのセット",
    "results": "見つかったカード",
    "searching": "検索中…",
    "clear": "消す",
    "none": "「{{text}}」に合うカードがありません。",
    "error": "カードを検索できませんでした。もう一度お試しください。",
    "number": "No. {{number}}",
    "set_loading": "…",
    "change": "別のカードを選ぶ",
    "create": "一覧にない？新しいカードを追加",
    "use_as_cert": "{{cert}} は鑑定品の番号です — これを使う"
  },
  "create": {
    "title": "カード図鑑に新しいカードを追加",
    "hint": "4つ入れれば大丈夫です。詳しい情報はあとからカード図鑑で足せます。",
    "save": "このカードを追加",
    "cancel": "やめる",
    "required": "入力してください",
    "duplicate": "このセットにはこのカードがすでにあります。",
    "twin": "このセットには番号 {{number}} のカードがすでにあります：",
    "use_existing": "このカードを使う"
  }
}
